import {ActionTypes} from './types';
import { ThunkResult } from '../../types';

export const fillInTheBlankAnswer = (questionId: string, data: any): ThunkResult => dispatch => {
  dispatch({
    type: ActionTypes.FILL_IN_THE_BLANK_ANSWER,
    payload: { questionId, data }
  });
};
